function getFilterArea(key) {
    return areaFilterData[key];
}
export var timeFilterKey = {
    night: 'night',
    day: 'day'
};
export var areaFilterKey = {
    stadiumArea: 'stadiumArea',
    streetArea: 'streetArea',
    gourmetArea: 'gourmetArea',
    playparkArea: 'playparkArea',
    enjoyJokohama: 'enjoyJokohama',
    specialStop: 'specialStop'
};
export var areaFilterData = {
    stadiumArea: {
        id: areaFilterKey.stadiumArea,
        color: '#0033CC',
        icon: '/images/areaguide/icons/stadium.svg',
        text: 'スタジアムエリア'
    },
    streetArea: {
        id: areaFilterKey.streetArea,
        color: '#B435E1',
        icon: '/images/areaguide/icons/street.svg',
        text: 'ストリートエリア'
    },
    gourmetArea: {
        id: areaFilterKey.gourmetArea,
        color: '#CC3D00',
        icon: '/images/areaguide/icons/gourmet.svg',
        text: 'グルメエリア'
    },
    playparkArea: {
        id: areaFilterKey.playparkArea,
        color: '#CEA407',
        icon: '/images/areaguide/icons/playpark.svg',
        text: 'プレイパークエリア'
    },
    enjoyJokohama: {
        id: areaFilterKey.enjoyJokohama,
        color: '#666666',
        icon: '/images/areaguide/icons/info.svg',
        text: '周辺を楽しむ'
    },
    specialStop: {
        id: areaFilterKey.specialStop,
        color: '#666666',
        icon: '/images/areaguide/icons/info.svg',
        text: '特別停留所'
    }
};
export var filterByArea = [
    {
        id: '',
        text: 'すべて'
    },
    {
        id: areaFilterKey.stadiumArea,
        text: getFilterArea(areaFilterKey.stadiumArea).text
    },
    {
        id: areaFilterKey.streetArea,
        text: getFilterArea(areaFilterKey.streetArea).text
    },
    {
        id: areaFilterKey.gourmetArea,
        text: getFilterArea(areaFilterKey.gourmetArea).text
    },
    {
        id: areaFilterKey.playparkArea,
        text: getFilterArea(areaFilterKey.playparkArea).text
    },
    {
        id: areaFilterKey.specialStop,
        text: getFilterArea(areaFilterKey.specialStop).text,
        disabled: false
    },
    {
        id: areaFilterKey.enjoyJokohama,
        text: getFilterArea(areaFilterKey.enjoyJokohama).text
    }
];
export var filterByTime = [
    {
        id: '',
        text: 'すべて'
    },
    {
        id: timeFilterKey.day,
        text: '昼を楽しむ'
    },
    {
        id: timeFilterKey.night,
        text: '夜を楽しむ'
    }
];
export var programs = [
    {
        id: 'program1',
        isPickUp: false,
        isSpecial: true,
        imageName: 'program1',
        area: getFilterArea(areaFilterKey.stadiumArea),
        time: [timeFilterKey.day],
        type: 'プログラム',
        title: 'DAY TIME PROGRAM',
        dateTime: '2022/12/03(土)〜2022/12/11(日) 10:00〜16:00',
        place: 'グラウンド内',
        fee: '無料',
        content: 'グラウンドがファミリーで楽しめる新しいアクティブスポットに！グラウンド中央に置かれた巨大ターンテーブルは自在に操作ができ、スイッチボタンを押したりと遊び方は自由。ショータイムでは、流れる音楽とリズムに合わせて身体を動かす企画を実施します。',
        partner: null
    },
    {
        id: 'program2',
        isSpecial: true,
        imageName: 'program2',
        area: getFilterArea(areaFilterKey.stadiumArea),
        time: [timeFilterKey.night],
        type: 'プログラム',
        title: 'NIGHT TIME PROGRAM',
        dateTime: '2022/12/03(土)〜2022/12/11(日) 17:00〜21:00',
        place: 'グラウンド内',
        fee: '無料',
        content: 'オリジナルプレイリストとインスタレーションで楽しむ、新感覚ミュージック×イルミネーションショーを開催。参加者自らがこの場で聞きたい音楽を決めるユーザープレイリストも用意しています。グラウンドビューでショーを楽しんだあとはスタンド席にてゆっくり鑑賞できるエリアも用意。さらに、今年はディスカバリーデッキを特別観覧エリア（有料）としてオープン。地上31mの高さから特別な鑑賞体験をお届けします。' +
            '<br/>※夜のプログラムはオンラインで入場整理券を配布中です。整理券がない場合でも各回先着順でご入場いただけますが、混雑状況によりお並びいただく時間が長引くことが予想されますので、予め整理券のお申し込みをお願いいたします。整理券のお申し込み方法等、詳細については本オフィシャルサイト内「チケット情報」をご確認ください。',
        partner: {
            text: 'チケット情報',
            link: '/#ticket'
        },
        introduce: {
            title: '夜の演出みどころ<br>「光と音楽」をテーマにした<br class="md:hidden">様々な光のアートを創出',
            slides: [
                {
                    image: '/images/areaguide/programs/program2_slide1.jpg',
                    content: '横浜スタジアム各所に色とりどりのレーザーが縦横無尽に展開され、幻想的な光の空間が出現。'
                },
                {
                    image: '/images/areaguide/programs/program2_slide2.jpg',
                    content: '巨大ビジョンでは音響とシンクロした映像演出を実施'
                },
                {
                    image: '/images/areaguide/programs/program2_slide3.jpg',
                    content: 'スタジアムの形状を活かしたならではの演出をご堪能ください！'
                }
            ]
        }
    },
    {
        id: 'program3',
        isPickUp: false,
        isSpecial: false,
        imageName: 'program3',
        area: getFilterArea(areaFilterKey.stadiumArea),
        time: [timeFilterKey.day, timeFilterKey.night],
        type: 'インスタレーション',
        title: 'ターンテーブル',
        dateTime: '2022/12/03(土)〜2022/12/11(日) 10:00〜21:00',
        place: 'グラウンド内',
        fee: '無料',
        content: 'グラウンド内に巨大ミュージックターンテーブルが出現。昼は巨大ターンテーブルを操作し、からだを動かしながら音を奏でる新しい演奏体験を、夜は特大ステージとして横浜スタジアムをミュージックパークに変貌させます。',
        partner: null
    },
    {
        id: 'program4',
        isPickUp: true,
        isSpecial: false,
        imageName: 'program4',
        area: getFilterArea(areaFilterKey.stadiumArea),
        time: [timeFilterKey.night],
        type: '特別プログラム',
        title: '特別観覧エリア',
        dateTime: '2022/12/03(土)〜2022/12/11(日) 17:00〜21:00（最終入場は20:45）',
        place: 'ディスカバリーデッキ',
        fee: '500円',
        content: '横浜スタジアムでの特別演出の開催期間中、夜間演出時に特別観覧エリアとしてディスカバリーデッキ入場券の販売を実施します。入場券は横浜スタジアム販売窓口にて各日当日券をご購入いただけます。',
        partner: {
            text: 'チケット情報',
            link: '/#ticket'
        },
        pickUpData: {
            dateTime: '12/3 SAT　13:00-17:00',
            type: '特別プログラム',
            title: '特別観覧エリア販売のご案内',
            content: '今年は横浜スタジアムでの特別演出の開催期間中、夜間演出時に特別観覧エリアとしてディスカバリーデッキ入場券の販売を実施します。地上31mからの眺望ビューをご堪能ください。入場券は横浜スタジアム販売窓口にて各日当日券をご購入いただけます。'
        },
        pickUpOrder: 2
    },
    {
        id: 'program5',
        isSpecial: false,
        imageName: 'program5',
        area: getFilterArea(areaFilterKey.stadiumArea),
        time: [timeFilterKey.day, timeFilterKey.night],
        type: 'インスタレーション',
        title: 'スノーピークベストセラーテントを常設',
        dateTime: '2022/12/03(土)〜2022/12/11(日) 10:00〜21:00',
        place: 'グラウンド内',
        fee: '無料',
        content: 'アウトドアメーカーのスノーピークがこれからキャンプをはじめたいなと考えている方におすすめする高品質かつ高いコストパフォーマンスを誇る3～4名用のベストセラーテント「アメニティドーム」を常設し休憩スポットとしてご利用いただけます。',
        partner: '協賛　<a href="https://www.instagram.com/snowpeak_yokohama_minatomirai/" target="_blank">株式会社スノーピーク</a>'
    },
    {
        id: 'program6',
        isSpecial: false,
        imageName: 'program6',
        area: getFilterArea(areaFilterKey.stadiumArea),
        time: [timeFilterKey.day],
        type: 'イベント',
        title: 'だれにでも演奏できる「ゆる楽器」',
        dateTime: '2022/12/10(土)〜2022/12/11(日) 12:00〜17:00',
        place: '正面ゲート上（2階）',
        fee: '無料',
        content: 'おもしろ楽器がいっぱい！音楽の経験がなくても、楽譜が読めなくても大丈夫。だれにでも演奏できて、すぐに合奏できる「ゆる楽器」を体験してください！',
        partner: '協賛　<a href="https://yurumusic.com/" target="_blank">世界ゆるミュージック協会</a>'
    },
    {
        id: 'program7',
        isSpecial: false,
        imageName: 'program7',
        area: getFilterArea(areaFilterKey.stadiumArea),
        time: [timeFilterKey.day],
        type: 'イベント',
        title: 'どこでもカホン',
        dateTime: 'カホン＆ピアノセッション演奏：2022/12/05(月),2022/12/06(火),2022/12/07(水)（12:00〜,14:00〜,15:00〜の3公演）<br/>どこでもカホン展示：2022/12/05(月)〜2022/12/11(日)',
        place: '横浜公園ステージ：2022/12/05(月)〜2022/12/07(水)<br/>コンコース（楽器エリア）：2022/12/08(木)〜2022/12/11(日)',
        fee: '無料',
        content: 'カホンは大人も子供も楽しめる人気の箱型の打楽器です。一般的なカホンは折りたたむことが出来ませんが、この「どこでもカホン」は折りたたんでコンパクトになりチューニングも出来るようにこだわり抜いて開発されています。音楽をより身近に感じてください。',
        partner: '協賛　<a href="https://minesawanobu.net" target="_blank">三祢沢 信</a>'
    },
    {
        id: 'program8',
        isSpecial: false,
        imageName: 'program8',
        area: getFilterArea(areaFilterKey.stadiumArea),
        time: [timeFilterKey.day],
        type: 'インスタレーション',
        title: 'tvkかながわMIRAI',
        dateTime: '2022/12/03(土)〜2022/12/11(日) 10:00〜16:00',
        place: '正面ゲート上（2階）',
        fee: '無料',
        content: 'わたしたちの暮らす神奈川県では、年間約7万人の新しい命を迎えます。ようこそ、かながわへ！この街にうまれてよかった、と子どもたちが感じてくれるように、神奈川の未来が光に満ちていますように、そんな願いと決意を込めて。',
        partner: '協賛　<a href="https://www.tvk-yokohama.com/mirai/" target="_blank">株式会社テレビ神奈川</a>'
    },
    {
        id: 'program9',
        isSpecial: false,
        imageName: 'program9',
        area: getFilterArea(areaFilterKey.stadiumArea),
        time: [timeFilterKey.day],
        type: 'イベント',
        title: 'ピアノ解体ショー',
        dateTime: '2022/12/10(土)' +
            '<br/>1回目　13:00～13:40' +
            '<br/>2回目　15:00～15:40',
        place: '横浜公園',
        fee: '無料',
        content: 'ピアノの中ってどうなっているの？ どうやって音を出しているの？ ピアノ解体ショーに参加して、知っているようで知らないピアノの世界をぜひ探検してみてください。',
        partner: '協賛　<a href="https://www.kawai.co.jp/" target="_blank">株式会社河合楽器製作所</a>'
    },
    {
        id: 'program10',
        isSpecial: false,
        imageName: 'program10',
        area: getFilterArea(areaFilterKey.stadiumArea),
        time: [timeFilterKey.day, timeFilterKey.night],
        type: 'インスタレーション',
        title: '音が可視化できるストリートピアノ',
        dateTime: '2022/12/08(木)〜2022/12/25(日) 10:00〜21:00' +
            '<br/>※音が可視化できるインスタレーションは2022/12/08(木)から開始。なお、ストリートピアノ自体は2022/12/03(土)から展示しております。',
        place: 'キッチンカーエリア',
        fee: '無料',
        content: 'どなたでも自由に演奏可能なShigeru Kawaiグランドピアノ「SK-3」を設置します。またデジタルインスタレーションの技術を用いてピアノとディスプレイを接続し、音を“見る”というあらたな楽しみ方をご提案します。',
        partner: '協賛　<a href="https://www.kawai.co.jp/" target="_blank">株式会社河合楽器製作所</a>'
    },
    {
        id: 'program11',
        isSpecial: false,
        imageName: 'program11',
        area: getFilterArea(areaFilterKey.stadiumArea),
        time: [timeFilterKey.day],
        type: '特別プログラム',
        title: '移動遊園地',
        dateTime: 'ロードトレイン：2022/12/3(土)～2022/12/11(日) 10:00〜16:00' +
            '<br/>巨大めいろ：2022/12/3(土),2022/12/4(日),2022/12/6(火),2022/12/8(木),2022/12/9(金),2022/12/10(土),2022/12/11(日) 10:00〜16:00' +
            '<br/>アスレチックラン：2022/12/3(土),2022/12/4(日),2022/12/10(土),2022/12/11(日) 10:00〜16:00',
        place: '正面ゲート上（2階）～コンコース、グラウンド内',
        fee: '有料（金額は現地にてお確かめください）',
        content: 'ロードトレイン：幸せを運ぶ新幹線ドクターイエローに乗ろう！' +
            '<br/>巨大めいろ：大きなふわふわめいろ迷わず脱出できるかな!?' +
            '<br/>アスレチックラン：全長20ｍの巨大アスレチックが登場！' +
            '<br/>他にも横浜スタジアムグラウンド内にはコンテンツが続々追加予定！',
        partner: '協賛 <a href="http://www.kids-life.com/" target="_blank">キッズ・ライフ・エンターテイメント株式会社</a>'
    },
    {
        id: 'program12',
        isSpecial: false,
        imageName: 'program12',
        area: getFilterArea(areaFilterKey.stadiumArea),
        time: [timeFilterKey.day, timeFilterKey.night],
        type: 'インスタレーション',
        title: '柄時雨（がらしぐれ） -日本の文様を学ぶ-',
        dateTime: '2022/12/03(土)〜2022/12/11(日) 10:00〜21:00',
        place: '人工大地',
        fee: '無料',
        content: '「縁を結ぶ場所~An Experience in Connection~」がコンセプトのエデュテインメント施設 ENNICHI。柄時雨は、その１コンテンツ。日本の歴史が生みだした美しい文様たち。色あざやかな舞台へといざない、魅了します。',
        partner: '協賛 <a href="https://ennichi.1-10.com/" target="_blank">株式会社ワントゥーテン</a>'
    },
    {
        id: 'program13',
        isSpecial: true,
        imageName: 'program13',
        area: getFilterArea(areaFilterKey.streetArea),
        time: [timeFilterKey.night],
        type: 'ライトアップ',
        title: '日本大通りライトアップ',
        dateTime: '2022/12/03(土)〜2022/12/25(日) 17:00〜23:00',
        place: '日本大通り（一部エリア）',
        fee: '無料',
        content: '日本大通り沿いのイチョウ並木が鮮やかにライトアップされます。約30体のトナカイのモニュメントも日本大通りの沿道沿いに並び、異国情緒溢れる幻想的な風景が広がります。<br/>' +
            '※ライトアップ時間は予告なく変更になる場合がございます。',
        partner: '共催　日本大通り活性化委員会'
    },
    {
        id: 'program14',
        isPickUp: false,
        isSpecial: false,
        imageName: 'program14',
        area: getFilterArea(areaFilterKey.streetArea),
        time: [timeFilterKey.day, timeFilterKey.night],
        type: 'イベント',
        title: '点灯セレモニー',
        dateTime: '2022/12/03(土) 15:30〜17:00',
        place: '日本大通り、横浜スタジアム',
        fee: '無料',
        content: 'BALLPARK FANTASIAの開催を記念して、点灯セレモニーを実施。横浜市内の学生による吹奏楽のマーチング演奏に合わせて、日本大通りのイチョウ並木が点灯します。先着で点灯セレモニーにご来場いただいただみなさまに光風船をプレゼント。横浜スタジアム内では特別なイルミネーション演出をお楽しみいただけます。雨天時の開催実施についてはオフィシャルサイトをご確認ください。',
        partner: null
    },
    {
        id: 'program15',
        isSpecial: true,
        imageName: 'program15',
        area: getFilterArea(areaFilterKey.gourmetArea),
        time: [timeFilterKey.day, timeFilterKey.night],
        type: 'イベント',
        title: 'キッチンカー',
        dateTime: '2022/12/03(土),2022/12/04(日) 10:00〜21:00' +
            '<br/>2022/12/05(月)〜2022/12/09(金) 15:00〜21:00' +
            '<br/>2022/12/10(土),2022/12/11(日) 10:00〜21:00' +
            '<br/>2022/12/17(土),2022/12/18(日),2022/12/24(土),2022/12/25(日) 10:00〜21:00' +
            '<br/>※開催時間は予告なく変更になる場合があります',
        place: '横浜公園内グルメエリア',
        fee: '無料（飲食物販は別）',
        content: '今年もキッチンカーが複数出店！横浜公園内の飲食休憩スペースにて購入いただいたフードやドリンクをお楽しみいただけます。飲食休憩スペース内では、飲食中の会話を控えた利用など感染症対策へのご協力をお願いいたします。',
        partner: null
    },
    {
        id: 'program16',
        isSpecial: false,
        imageName: 'program16',
        area: getFilterArea(areaFilterKey.gourmetArea),
        time: [timeFilterKey.day, timeFilterKey.night],
        type: 'インスタレーション',
        title: 'LEDインテリア Refala',
        dateTime: '2022/12/03(土)〜2022/12/11(日) 10:00〜21:00',
        place: '横浜公園グルメエリア、グラウンド内、特別観覧エリア（ディスカバリーデッキ）',
        fee: '無料',
        content: '特別な光の空間を演出するRefala（リファラ）。フォトジェニックでおしゃれな写真を撮影してみてください。',
        partner: '協賛　<a href="https://www.rakuten.ne.jp/gold/kinokokinoko/sp/interior/index.html" target="_blank">株式会社HAPPY JOINT</a>'
    },
    {
        id: 'program17',
        isSpecial: false,
        imageName: 'program17',
        area: getFilterArea(areaFilterKey.gourmetArea),
        time: [timeFilterKey.day, timeFilterKey.night],
        type: 'インスタレーション',
        title: 'ベルギー発のコンテンポラリー家具',
        dateTime: '2022/12/03(土)〜2022/12/11(日) 10:00〜21:00',
        place: '横浜公園グルメエリア',
        fee: '無料',
        content: '岩をモチーフした１人掛けソファーです。ボリューム感のあるサイズでインパクトのあるデザインですが、座面と背もたれの傾斜が独特の座り心地となっています。ぜひ会場にてお試しください！',
        partner: '協賛　<a href="https://sixinch.jp/" target="_blank">株式会社sixinch.JAPAN</a>'
    },
    {
        id: 'program18',
        isSpecial: false,
        imageName: 'program18',
        area: getFilterArea(areaFilterKey.gourmetArea),
        time: [timeFilterKey.day, timeFilterKey.night],
        type: 'インスタレーション',
        title: '鼓動する畳 TTM-V20',
        dateTime: '2022/12/03(土)〜2022/12/25(日) 10:00〜21:00',
        place: '正面ゲート上（2階）：2022/12/03(土)〜2022/12/11(日)<br/>キッチンカーエリア：2022/12/12(月)〜2022/12/25(日)',
        fee: '無料',
        content: '振動スピーカーを畳の内部に6機搭載し、畳に「ごろ寝」することで音と振動を全身で感じることができる「鼓動する畳」 。⽇本⼀を誇る畳の産地、熊本・⼋代発の新商品開発プロジェクト「YATSUSHIRO TATAMIx」の第一弾プロダクトです。',
        partner: '協賛　<a href="https://yatsushiro-tatami.jp/tatamix/ttm-v20/" target="_blank">八代産畳表認知向上・需要拡大推進協議会</a>'
    },
    {
        id: 'program19',
        isSpecial: false,
        imageName: 'program19',
        area: getFilterArea(areaFilterKey.gourmetArea),
        time: [timeFilterKey.day, timeFilterKey.night],
        type: 'イベント',
        title: 'スマドリバー',
        dateTime: '2022/12/3(土)～2022/12/4(日) 11:00〜21:00' +
            '<br/>2022/12/5(月)～2022/12/9(金) 16:00〜21:00' +
            '<br/>2022/12/10(土)～2022/12/11(日) 11:00〜21:00',
        place: '横浜公園内グルメエリア',
        fee: '無料（飲食物販は別）',
        content: '飲める人も飲めない人も、自分の気分や体調、シーンに合わせて楽しめる「飲み方の多様性＝スマートドリンキング」を体験いただけます。',
        partner: '協賛　<a href="https://www.sumadoribar-shibuya.jp/" target="_blank">アサヒビール株式会社</a>'
    },
    {
        id: 'program20',
        isSpecial: true,
        imageName: 'program20',
        area: getFilterArea(areaFilterKey.playparkArea),
        time: [timeFilterKey.day],
        type: 'イベント',
        title: 'プレイパークエリア',
        dateTime: '2022/12/03(土)〜2022/12/25(日）',
        place: '横浜公園内プレイパークエリア',
        fee: '無料（一部コンテンツ有料）',
        content: '横浜公園内では様々なイベントを実施予定。体験型のワークショップやマルシェまで親子で楽しめるコンテンツが充実！' +
            '<br/>各コンテンツの開催日程、時間についてはエリアガイド内「プレイパークエリア」からご確認ください。',
        partner: null
    },
    {
        id: 'program21',
        isSpecial: false,
        imageName: 'program21',
        area: getFilterArea(areaFilterKey.playparkArea),
        time: [timeFilterKey.night],
        type: 'ライトアップ',
        title: '横浜スタジアム外壁ライトアップ',
        dateTime: '2022/12/03(土)〜2022/12/25(日) 17:00〜21:00',
        place: '横浜スタジアム外壁',
        fee: '無料',
        content: '今年も横浜スタジアムの外壁が色とりどりにライトアップ！<br/>' +
            '※ライトアップ時間は予告なく変更になる場合がございます。',
        partner: null
    },
    {
        id: 'program22',
        isSpecial: true,
        imageName: 'program22',
        area: getFilterArea(areaFilterKey.playparkArea),
        time: [timeFilterKey.day],
        type: 'イベント',
        title: 'ヨコハマSDGsデザインセンターイベント',
        dateTime: '2022/12/10(土),2022/12/11(日) 10:00〜16:00',
        place: '横浜公園内プレイパークエリア',
        fee: '無料',
        content: '楽しみながらSDGsを体験できるイベントを開催します。ジョギングをしながら街のゴミを拾っていく「プロギング」や近距離モビリティ（電動車椅子）の体験試乗会、サーカス道具を用いた体験、ステージでのショーなど、お子様だけでなくご家族も揃って、楽しみながら様々なSDGsに触れられる体験を提供します。',
        partner: '協賛　<a href="https://www.yokohama-sdgs.jp/topics/2022ballparkfantasia/" target="_blank">ヨコハマSDGsデザインセンター</a>'
    },
    {
        id: 'program23',
        isSpecial: false,
        imageName: 'program23',
        area: getFilterArea(areaFilterKey.playparkArea),
        time: [timeFilterKey.day],
        type: 'ワークショップ',
        title: '環境講座＆ワークショップ',
        dateTime: '2022/12/10(土)' +
            '<br/>第1回　10:00〜11:00' +
            '<br/>第2回　11:00〜12:00' +
            '<br/>※各回最大12名、事前予約制' +
            '<br/>※予約方法、リンクについては後日こちらのページにて公開いたします' +
            '<br/>※予告なく日時が変更になる場合がございます、あらかじめご了承ください',
        place: '横浜公園内プレイパークエリア',
        fee: '無料',
        content: 'よりすこやかな地球のために、一人ひとりいま何ができるかを考える講座です。花王の包装容器に関する取り組みをご紹介しながら、プラスチックの削減について考えます。講座の最後には、オリジナルスマートホルダーを作成して頂きます。',
        partner: '協賛　<a href="https://t.livepocket.jp/e/l_al6" target="_blank">花王グループカスタマーマーケティング株式会社</a>'
    },
    {
        id: 'program24',
        isSpecial: false,
        imageName: 'program24',
        area: getFilterArea(areaFilterKey.playparkArea),
        time: [timeFilterKey.day],
        type: 'ブース',
        title: 'NEXT ESSENTIAL STORE',
        dateTime: '2022/12/10(土),2022/12/11(日) 10:00〜16:00',
        place: '横浜公園内プレイパークエリア',
        fee: '無料',
        content: '少しだけ未来の当たり前。そこで当たり前のように使われている素材を一度思い浮かべてみませんか? 植物由来の新素材PlaXをはじめとする、私たちにとっても、地球にとってもやさしい「ネクスト・エッセンシャル」な素材を使った商品をご紹介します。',
        partner: '協賛　<a href="https://www.bioworks.co.jp/" target="_blank">Bioworks株式会社</a>'
    },
    {
        id: 'program25',
        isSpecial: false,
        imageName: 'program25',
        area: getFilterArea(areaFilterKey.playparkArea),
        time: [timeFilterKey.day, timeFilterKey.night],
        type: 'イベント',
        title: 'アップサイクルウエディングドレスのお披露目',
        dateTime: '2022/12/11(日) 13:00〜14:00',
        place: '横浜公園内プレイパークエリア',
        fee: '無料',
        content: '役目を終え、廃棄されるはずだったウェディングドレスを生地、レース、ビーズなどのパーツに分け、それらを組み合わせて創り上げたアップサイクルドレスをお披露目します。',
        partner: '協賛　株式会社テイクアンドギヴ・ニーズ' +
            '<br><a href="https://www.tgn.co.jp/company/" target="_blank">https://www.tgn.co.jp/company/</a>' +
            '<br><a href="https://mirrormirror.jp/" target="_blank">https://mirrormirror.jp/</a>'
    },
    {
        id: 'program26',
        isSpecial: false,
        imageName: 'program26',
        area: getFilterArea(areaFilterKey.playparkArea),
        time: [timeFilterKey.day],
        type: 'イベント',
        title: 'プロキング@BALLPARK FANTASIA',
        dateTime: '2022/12/10(土) 08:30〜10:30',
        place: '横浜公園内プレイパークエリア',
        fee: '無料',
        content: 'ジョギングをしながらごみを拾うスポーツ「プロギング」！' +
            '<br/>走って健康に、拾ってエコに、誰でも気軽に参加していただくことができるプロギングを開催します。難しいルールもないので、ご自身のペースで楽しく一緒に横浜のまちを走りながらSDGsに取り組みましょう！' +
            '<br/>参加には事前予約が必要となります。下記のリンクよりご予約ください。',
        partner: '<a href="https://plogging.jp/?pid=171562863" target="_blank">https://plogging.jp/?pid=171562863</a>'
    },
    {
        id: 'program27',
        isSpecial: false,
        imageName: 'program27',
        area: getFilterArea(areaFilterKey.playparkArea),
        time: [timeFilterKey.day, timeFilterKey.night],
        type: 'イベント',
        title: '三浦野菜マルシェ',
        dateTime: '2022/12/09(金),2022/12/10(土),2022/12/11(日) 10:00〜21:00',
        place: '横浜公園内プレイパークエリア',
        fee: '無料',
        content: '神奈川県内における農産物の一大産地である三浦市で採れた野菜を直送し、品質が高く、鮮度のいい状態で三浦野菜を購入できるマルシェを開催します！' +
            '<br/>【ブース出店情報/時間】' +
            '<br/>ヨコスカアグリファミリー/10:00〜15:00/野菜販売' +
            '<br/>三浦海業公社（うらり) /10:00〜21:00/野菜、稲荷寿司',
        partner: '協賛　<a href="https://yokohama.cocoonfamily.jp/feature/ballpark_fantasia2022" target="_blank">京浜急行電鉄株式会社</a>'
    },
    {
        id: 'program28',
        isSpecial: false,
        imageName: 'program28',
        area: getFilterArea(areaFilterKey.playparkArea),
        time: [timeFilterKey.day],
        type: 'イベント',
        title: '233アートフリーマーケット',
        dateTime: '2022/12/03(土),2022/12/04(日),2022/12/10(土),2022/12/11(日),2022/12/24(土),2022/12/25(日) 10:00〜16:00',
        place: '横浜公園内プレイパークエリア',
        fee: '無料',
        content: '世田谷・三軒茶屋にあるギャラリー世田谷233のクリエイターさんたちがブース出展。オリジナルアート、ハンドメイド作品の展示＆販売を行います。',
        partner: '協賛　<a href="http://233.jp/" target="_blank">世田谷233</a>'
    },
    {
        id: 'program29',
        isSpecial: false,
        imageName: 'program29',
        area: getFilterArea(areaFilterKey.playparkArea),
        time: [timeFilterKey.day, timeFilterKey.night],
        type: 'インスタレーション',
        title: 'フォレストドーム・テント東屋',
        dateTime: '2022/12/03(土)〜2022/12/25(日) 10:00〜21:00',
        place: '横浜公園内プレイパークエリア',
        fee: '無料',
        content: '間伐材を使ったドーム型のテント東屋です。どこでも手軽に設置することができます。畑の中の休憩所や野菜直売所として、ドックランに、屋外カフェに、幼稚園の園庭などに使われています。日本の森林を守る活動にも貢献しています。',
        partner: '協賛　<a href="https://forestdome.net" target="_blank">北村淳建築設計事務所</a>'
    },
    {
        id: 'program30',
        isSpecial: false,
        imageName: 'program30',
        area: getFilterArea(areaFilterKey.playparkArea),
        time: [timeFilterKey.day],
        type: '特別プログラム',
        title: 'MIO -美音- ハンドパン＆ギター',
        dateTime: '2022/12/24(土),2022/12/25(日) 13:00〜14:00',
        place: '横浜公園内プレイパークエリア',
        fee: '無料',
        content: '世界的にも珍しいハンドパンとギターのユニットMIO美音。打楽器奏者・立花朝人とギタリスト・伊藤智美が優しく、切なく時に激しいサウンドを奏でます。',
        partner: '協賛　<a href="https://www.mio2021.com/" target="_blank">ＭＩＯ－美音－</a>'
    },
    {
        id: 'program31',
        isSpecial: false,
        imageName: 'program31',
        area: getFilterArea(areaFilterKey.playparkArea),
        time: [timeFilterKey.day],
        type: '特別プログラム',
        title: 'MASH handpan. 奏でよう、 美しい音色',
        dateTime: '2022/12/03(土),2022/12/10(金) 13:00〜14:00',
        place: '横浜公園内プレイパークエリア',
        fee: '無料',
        content: 'ハンドパンはUFOのような形をした、一瞬にして人を虜にする美しい音色を発する珍しい楽器です。世界的にも注目されております。MASH handpanは、職人がステンレス素材から手作りしています。丁寧に手槌で打つことで、美しい音を生み出します。',
        partner: '協賛　<a href="https://mashhandpan.com" target="_blank">MASH株式会社</a>'
    },
    {
        id: 'program32',
        isSpecial: false,
        imageName: 'program32',
        area: getFilterArea(areaFilterKey.playparkArea),
        time: [timeFilterKey.day, timeFilterKey.night],
        type: '特別プログラム',
        title: 'Good Ethical Company produced by SEMBA',
        dateTime: '詳細やワークショップ開催日は、セレクトショップ下記のリンクの公式SNSをご確認ください。',
        place: '横浜公園内プレイパークエリア',
        fee: '無料',
        content: 'オリジナ ルのセレクトショップ「Good Ethical Company produced by SEMBA」を出展いたします。複数の企業とコラボし、エシカルな商品のセレクトショップのほか、開催期間中は「食べられるお野菜ブーケづくり」「丸太切り体験」「ペーパービーズストラップづくり」「クリスマスツリーづくり」などの様々なワークショップを実施します。',
        partner: '協賛　<a href="https://twitter.com/popup_semba" target="_blank">株式会社船場</a>'
    },
    {
        id: 'program33',
        isSpecial: false,
        imageName: 'program33',
        area: getFilterArea(areaFilterKey.playparkArea),
        time: [timeFilterKey.day, timeFilterKey.night],
        type: '特別プログラム',
        title: 'Hybrid Live Entertainment "OZ"',
        dateTime: '詳細は下記のリンクの公式SNSをご確認ください。',
        place: '横浜公園内プレイパークエリア',
        fee: '未定',
        content: 'オズの魔法使いをテーマにしたVRミュージカル。VRデバイスを装着して、圧倒的な没入体験の世界へ。' +
            '<br/>体験時間：12分',
        partner: '協賛　<a href="https://twitter.com/TSPtaiyo_pr?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor" target="_blank">TSP太陽株式会社</a>'
    },
    {
        id: 'program34',
        isSpecial: false,
        imageName: 'program34',
        area: getFilterArea(areaFilterKey.playparkArea),
        time: [timeFilterKey.day, timeFilterKey.night],
        type: 'ブース',
        title: '横浜COON紹介ブース',
        dateTime: '2022/12/03(土),2022/12/04(日) 10:00〜21:00',
        place: '横浜公園内プレイパークエリア',
        fee: '無料',
        content: '話題のグリスロ「横浜COCOON」についての紹介やグッズの販売を実施。' +
            '<br/>※満員御礼について期間中走行予定の「横浜COCOON」乗車枠については募集を終了しております',
        partner: '協賛　<a href="https://yokohama.cocoonfamily.jp/feature/ballpark_fantasia2022" target="_blank">京浜急行電鉄株式会社</a>'
    },
    {
        id: 'program35',
        isSpecial: false,
        imageName: 'program35',
        area: getFilterArea(areaFilterKey.specialStop),
        time: [timeFilterKey.day, timeFilterKey.night],
        type: 'モビリティ',
        title: 'きらぼし号',
        dateTime: '2022/12/10(土)' +
            '<br/>各日8便' +
            '<br/>※時刻表はYOKOHAMA MUSIC HARBORパンフレットまたwebを参照',
        place: '特別停留所（BAYS前）',
        fee: '無料',
        content: 'YOKOHAMA MUSIC HARBOR 2022 CHRISTMASの12/10(土)限定モビリティ。赤レンガ倉庫と横浜スタジアムをつなぎます。水素と酸素の化学反応発電によるクリーンなバス『きらぼし号』に乗って、光輝く街を眺めながら横浜の街を巡ってみてはいかがでしょうか。',
        partner: '協賛　<a href="https://sp.ure.pia.co.jp/widget/a/yokohama2022" target="_blank">株式会社きらぼし銀行</a>'
    },
    {
        id: 'program36',
        isSpecial: false,
        imageName: 'program36',
        area: getFilterArea(areaFilterKey.specialStop),
        time: [timeFilterKey.day, timeFilterKey.night],
        type: 'モビリティ',
        title: 'YOKOHAMA MUSIC HARBOR 2022コラボ ビアバイクツアー',
        dateTime: '2022/12/03(土),2022/12/10(土)',
        place: '特別停留所（BAYS前）',
        fee: '5,000円/人' +
            '<br/>※事前申し込み必須' +
            '<br/>※定員に達し次第募集枠終了',
        content: '横浜・みなとみらい地区の景色と生演奏を楽しみながらのビアバイク！' +
            '<br/>クラフトビール醸造所の見学も付いた横浜ならではのツアーです！' +
            '<br/>※YOKOHAMA MIDNIGHT HARBORとのコラボイベントです。',
        partner: '協賛　<a href="http://www.yokohamabeer.com/BEERBIKE.html" target="_blank">株式会社横浜ビール</a>'
    },
    {
        id: 'program37',
        isSpecial: false,
        imageName: 'program37',
        area: getFilterArea(areaFilterKey.specialStop),
        time: [timeFilterKey.day, timeFilterKey.night],
        type: 'モビリティ',
        title: 'オープントップバス',
        dateTime: '2022/12/10(土),2022/12/11(日)  運行時間については「オープントップバス」公式サイトよりご確認ください。',
        place: '特別停留所（BAYS前）',
        fee: '未定',
        content: '横浜駅周辺からBALLPARK FANTASIA会場間を走行するオープントップバス。コロナ禍でも安心な屋根のない開放的なオープントップバス仕様です。' +
            '<br/>各日7便走行予定。',
        partner: '協賛　<a href="https://widgets.bokun.io/online-sales/e27f674a-ea9a-47f0-a2ec-78902c8f252a/experience/730073" target="_blank">株式会社JTB</a>'
    },
    {
        id: 'program38',
        isSpecial: false,
        imageName: 'program38',
        area: getFilterArea(areaFilterKey.enjoyJokohama),
        time: [timeFilterKey.day, timeFilterKey.night],
        type: 'イベント',
        title: 'YOKOHAMA MUSIC HARBOR 2022 CHRISTMAS',
        dateTime: '2022/12/03(土),2022/12/10(土)13:00〜23:00',
        place: 'コンテンツにより異なる',
        fee: '無料（一部コンテンツ有料）',
        content: '“音楽の力”でMM21エリアを盛り上げるスペシャルイベント。2回目となる今回はクリスマスシーズンを舞台に、駅の構内、観光スポット、周遊モビリティなど、街の至る所で音楽を感じながら楽しい時間を過ごせるコンテンツを展開。パンフレットPASS提示で割引も！',
        partner: '企画総合プロデュース:ぴあ（株）/2022年度公益信託みなとみらい21まちづくりトラスト認定助成イベント' +
            '<br/><a href="https://sp.ure.pia.co.jp/widget/a/yokohama2022" target="_blank">https://sp.ure.pia.co.jp/widget/a/yokohama2022</a>'
    },
    {
        id: 'program39',
        isSpecial: false,
        imageName: 'program39',
        area: getFilterArea(areaFilterKey.enjoyJokohama),
        time: [timeFilterKey.day, timeFilterKey.night],
        type: 'イベント',
        title: 'ヨルノヨ',
        dateTime: '2022/11/24(木)〜2023/01/03(火)17:00〜21:05',
        place: '横浜都心臨海部',
        fee: '無料',
        content: '横浜の都心臨海部で展開するアートイルミネーション。大さん橋からは、歴史的建造物や港の水際線、近代ビル群など34もの施設が連動し、光と音楽でダイナミックに躍動する時間限定の演出を楽しめる。また、今回、新港中央広場に加え、新たな会場として「大さん橋ふ頭ビル」や「山下公園」でもプロジェクションを実施。お得に街巡りが楽しめる企画も多数用意。',
        partner: "主催　<a href='https://yorunoyo.yokohama/' target='_blank'>クリエイティブ・ライト・ヨコハマ実行委員会</a>"
    },
    {
        id: 'program40',
        isSpecial: false,
        imageName: 'program40',
        area: getFilterArea(areaFilterKey.enjoyJokohama),
        time: [timeFilterKey.day, timeFilterKey.night],
        type: '連携店舗',
        title: 'Billboard Live YOKOHAMA',
        dateTime: '店舗営業時間については、HPよりご確認ください。',
        place: '横浜市中区北仲通５丁目５７−２ 1F KITANAKA BRICK&WHITE',
        fee: '',
        content: '100年以上の歴史を持ち、世界で最も信頼される音楽ブランドである“ビルボード”の名のもと、国内外のトップクラスのアーティストが出演。そのパフォーマンスを堪能する至福の時間のために、一流のシェフによる料理と選りすぐりのドリンク、快適なインテリアをご用意して、皆様をお待ちしております。',
        partner: "<a href='http://www.billboard-live.com/pg/shop/index.php?mode=top&shop=4' target='_blank'>Billboard Live YOKOHAMA</a>"
    },
    {
        id: 'program41',
        isSpecial: false,
        imageName: 'program41',
        area: getFilterArea(areaFilterKey.enjoyJokohama),
        time: [timeFilterKey.night],
        type: 'ライトアップ',
        title: '関東学院大学 新キャンパス前の大通り公園のイルミネーション',
        dateTime: '2022/12/03(土)〜2022/12/11(日)17:00〜22:00',
        place: '大通り公園',
        fee: '無料',
        content: '今年、新設された関東学院大学 横浜・関内キャンパス前の大通り公園にイルミネーションコーンが出現。',
        partner: '協賛　関東学院大学'
    },
    {
        id: 'program42',
        isSpecial: false,
        imageName: 'program42',
        area: getFilterArea(areaFilterKey.enjoyJokohama),
        time: [timeFilterKey.night],
        type: 'ライトアップ',
        title: '関東学院大学 横浜・関内キャンパスのクリスマスツリー',
        dateTime: '2022/12/03(土)〜2022/12/25(日)17:00〜22:00',
        place: '関東学院キャンパス軒先',
        fee: '無料',
        content: '関東学院大学では、新キャンパス軒先の大きなクリスマスツリーでクリスマスをお祝い。さらに、地下１階のサンクンガーデンには、建築・環境学部が製作した木製のイルミネーションオブジェも。',
        partner: '協賛　関東学院大学'
    },
    {
        id: 'program43',
        isSpecial: false,
        imageName: 'program43',
        area: getFilterArea(areaFilterKey.enjoyJokohama),
        time: [timeFilterKey.day, timeFilterKey.night],
        type: 'ライトアップ',
        title: '横浜市旧市庁舎仮囲い アート/ライトアップ',
        dateTime: '2022/12/03(土)〜2022/12/11(日)17:00〜23:00',
        place: '横浜市旧市庁舎',
        fee: '無料',
        content: 'JR関内駅南口では、「横浜市旧市庁舎街区活用事業」が2022年7月より着工しております。この仮囲いを活用し、KOMESENNIN×KACのユニットによるアート掲示とライトアップを行います。',
        partner: '協賛　<a href="https://www.mitsuifudosan.co.jp/corporate/news/2022/0712/" target="_blank">三井不動産株式会社( 横浜市旧市庁舎街区活用事業 事業者代表企業)</a>'
    },
    {
        id: 'program44',
        isSpecial: false,
        imageName: 'program44',
        area: getFilterArea(areaFilterKey.enjoyJokohama),
        time: [timeFilterKey.day, timeFilterKey.night],
        type: '連携店舗',
        title: '&LIVE（アンドライブ）',
        dateTime: '店舗営業時間については、HPよりご確認ください。        ',
        place: '横浜市中区尾上町2丁目18番1号 YSビル 地下1F',
        fee: '',
        content: 'ハマスタから徒歩3分のDeNA直営ライブエンターテインメントバー。BPF開催を記念して期間中は特別ドリンクを店内にて販売予定！超大型ビジョンで大迫力のライブコンテンツをお楽しみください！※ライブスケジュールはHPよりご確認ください。',
        partner: ' <br> <a href="https://andlive.dena.com/?utm_source=bpfofficial&utm_medium=link&utm_campaign=bpf" target="_blank">https://andlive.dena.com/</a> '
    }
];
